<template>
  <div class="columns is-gap is-multiline">
    <div v-for="(faceNumerique, index) in detailPanneauxNumerique"
      :key="index"
      class="column is-half-tablet is-one-third-desktop">
      <div :class="{'selectt': faceNumerique.select}" class="is-height-per">
        <div class="columns is-mobile is-marginless">
        <div class="column is-relative is-paddingless is-height-200">
          <img :src="url(faceNumerique.urlPhoto)" class="imageBg" alt="">
          <div @click="afficheFace(index)" class="pointer level bgBande">
            <div class="level-left has-text-white">
              <div class="media margin_media"
                  v-if="faceNumerique.extensionOpportunite.quantite &&
                  faceNumerique.extensionOpportunite.typeTarification">
                <b-icon
                  icon="timer"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                  <label>Durée :</label><br>
                  <p class="p_size14 has-text-weight-bold">
                    {{formatDureeNum(
                      faceNumerique.extensionOpportunite.typeTarification,
                      faceNumerique.extensionOpportunite.quantite)}}
                  </p>
                </div>
              </div>
            </div>
            <div
              class="level-right"
              v-if="faceNumerique.extensionOpportunite.tarifHt">
              <p
                class="p_size18 has-text-weight-bold has-text-white goToLeft">
                {{tarifHt(
                  faceNumerique.extensionOpportunite.tarifHt*
                  faceNumerique.extensionOpportunite.quantite)}}
              </p>
            </div>
          </div>
          </div>
          <div class="column is-narrow espace-icon pb-0">
            <div class="has-text-centered mb-btnaction">
              <div class="icon-forme pointer" :class="{'icon-select': faceNumerique.select}"
                @click="contolSelect(index)">
                <b-icon icon="cart"
                type="is-white" custom-class="icon-position"></b-icon>
              </div>
              <p class="p_size10 has-text-default ml-5px" v-if="!faceNumerique.select">
                Sélectionner</p>
              <p class="p_size10 has-text-default ml-5px" v-else>
                Retirer</p>
            </div>
            <div class="has-text-centered mb-btnaction">
              <div class="icon-forme pointer topViolet" @click="afficheFace(index)">
                <b-icon icon="information"
                type="is-white" custom-class="icon-position"></b-icon>
              </div>
              <p class="p_size10 has-text-default ml-5px">
                Plus d'infos</p>
            </div>
          </div>
        </div>
        <div @click="afficheFace(index)" class="pointer infoBorder has-background-white
          height-calc-auto">
          <div class="leftViolet topViolet rightViolet bottomVert">
            <label class="has-text-default">Adresse </label>
            <p class="has-text-dark has-text-weight-bold p_size14">
              {{adresse(faceNumerique)}}
            </p>
          </div>
          <div class="column leftViolet rightViolet">
            <div class="columns is-multiline color-icon">
              <div
                class="column bottomVert is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="vector-intersection"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Format
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{faceNumerique.format}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="column bottomVert is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="package-variant-closed"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Matériel
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{faceNumerique.materiel}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="column bottomVert is-paddingless is-6"
                v-if="faceNumerique.extensionOpportunite.quantite &&
                  faceNumerique.extensionOpportunite.typeTarification">
                <div class="media">
                  <b-icon
                    icon="cellphone-screenshot"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Mode de diffusion
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{modeDiff(faceNumerique.extensionOpportunite.typeTarification)}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="column bottomVert is-paddingless is-6">
                <div
                  v-if="faceNumerique.extensionOpportunite.nbDiffusion"
                  class="media">
                  <b-icon
                    icon="counter"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Diffusion/jour
                    </label>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{faceNumerique.extensionOpportunite.nbDiffusion}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column bottomVert is-paddingless is-12">
              <div
                v-if="faceNumerique.extensionOpportunite.commentaire"
                class="media">
                <div class="media-content">
                  <label class="has-text-weight-bold has-text-link p_size14">
                    Commentaire :
                  </label>
                  <p class="has-text-default p_size12">
                    {{faceNumerique.extensionOpportunite.commentaire}}
                  </p>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition
        name="custom-classes-transition"
        enter-active-class="animated slideInRight"
        leave-active-class="animated slideOutRight"
        :duration="300"
        v-on:after-enter="bg = true"
        v-on:after-leave="bg = false">
      <app-detail-opportunites :bg="bg" :detailFaceNumerique="detailFaceNumerique" v-if="show"/>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/general/iconColorGetter';
import { formatNum, formatAdresse, formatDureeNum, modeDiff, urlPhoto } from '@/services/opportunite/formatTab';
import detailOpportunites from './detailOpportunites';

export default {
  name: 'listeFacesNumerique',
  props: ['detailPanneauxNumerique'],
  components: {
    appDetailOpportunites: detailOpportunites,
  },
  data() {
    return {
      show: false,
      detailFaceNumerique: {},
      bg: false,
    };
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect(i) {
      this.detailPanneauxNumerique[i].select = !this.detailPanneauxNumerique[i].select;
      if (this.detailPanneauxNumerique[i].select) {
        this.detailPanneauxNumerique[i].icon = iconColorGetter('#49db70', TAILLE_ICON_GRAND);
        this.add(this.detailPanneauxNumerique[i].extensionOpportunite.tarifHt);
        this.addNbSelect();
      } else {
        this.detailPanneauxNumerique[i].icon = iconColorGetter('#009ce0', TAILLE_ICON_GRAND);
        this.substract(this.detailPanneauxNumerique[i].extensionOpportunite.tarifHt);
        this.substractNbSelect();
      }
    },
    afficheFace(i) {
      this.detailFaceNumerique = this.detailPanneauxNumerique[i];
      this.show = true;
    },
    tarifHt(t) {
      return formatNum(t);
    },
    adresse(data) {
      return formatAdresse(data);
    },
    modeDiff(t) {
      return modeDiff(t);
    },
    formatDureeNum(t, q) {
      return formatDureeNum(t, q);
    },
    url(u) {
      return urlPhoto(u);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/panneauxNumeriques/listesFacesNumerique.vue